import { useEffect } from "react";
import { useLocation } from "wouter";

export default function AdminVerifications() {
  const [, navigate] = useLocation();
  useEffect(() => {
    navigate("/admin?tab=verifications");
  }, [navigate]);

  return null;
}
